module.exports = __webpack_public_path__ + "img/x ray 1.9bb13955.svg";